import React, {Component} from 'react';
import {Avatar} from '@material-ui/core';

class UecareAvatarUpload extends Component {

    constructor(props) {
        super(props);
        this.handleFileSelect = this.handleFileSelect.bind(this); // 讓 handleFileSelect 中的 this.refs 不會 undefined
    }

    handleFileSelect(e) {
        e.preventDefault(); // 取消原有的功能
        this.refs.fileUploader.click();
    }

    getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                resolve(reader.result);
            };
            reader.onerror = function (error) {
                reject(error);
            };
        });
    };

    handleFileChange = async (controller) => {
        try {
            const base64Image = await this.getBase64(this.refs.fileUploader.files[0]);
            if (this.props.onClick) await this.props.onClick(base64Image);
        } catch (e) {
            return null;
        }
    };

    render() {

        return (
            <div className="flex">
                <input type="file" id="fileUploader" ref="fileUploader"
                       onChange={this.handleFileChange} style={{display: "none"}}/>
                <Avatar
                    className={this.props.className}
                    alt="頭像"
                    src={this.props.src}
                    onClick={this.handleFileSelect}/>
            </div>
        );
    }
}


export default UecareAvatarUpload;



// WEBPACK FOOTER //
// ./src/components/UecareAvatarUpload.js